import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable()
export class ServicioToken {
  constructor(private jwt: JwtHelperService) {}

  decodeToken() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      if (tokenDecoded) {
        return tokenDecoded;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getToken() {
    if (localStorage.getItem("AccessToken")) {
      return localStorage.getItem("AccessToken");
    } else {
      return null;
    }
  }

  getUsername() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const username =
        tokenDecoded[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
        ];
      if (username) {
        return username;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getMunicipio() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const idMunicipio = tokenDecoded["idMunicipio"];
      if (idMunicipio) {
        return idMunicipio;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getRol() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const roles =
        tokenDecoded[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ];
      if (roles) {
        return roles;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getUserId() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const id = tokenDecoded["unique_name"];
      if (id) {
        return id;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getNif() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const id = tokenDecoded["nif"];
      if (id) {
        return id;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getIdTercero() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const idTercero = tokenDecoded["idtercero"];
      if (idTercero) {
        return idTercero;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getIdCliente() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const idCliente = tokenDecoded["idcliente"];
      if (idCliente) {
        return idCliente;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getIdAplicacionCliente() {
    if (localStorage.getItem("AccessTokem")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const idAplicacionCliente = tokenDecoded["idaplicacioncliente"];
      if (idAplicacionCliente) {
        return idAplicacionCliente;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getIdApoderado() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const idApoderado = tokenDecoded["idapoderado"];
      if (idApoderado) {
        return idApoderado;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getNombre(): string | null {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const nombre = tokenDecoded["nombre"];
      if (nombre) {
        return nombre;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  isAdmin() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const tipoacceso = tokenDecoded["tipoacceso"];
      if (tipoacceso === "Privado") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getParametros() {
    if (localStorage.getItem("AccessToken")) {
      const tokenDecoded = this.jwt.decodeToken(
        localStorage.getItem("AccessToken"),
      );
      const parametros = tokenDecoded["parametros"];
      if (parametros) {
        return JSON.parse(parametros);
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  isTokenExpired(): boolean {
    if (localStorage.getItem("RefreshToken")) {
      return this.jwt.isTokenExpired(localStorage.getItem("RefreshToken"));
    } else {
      return true;
    }
  }
}
